import { Gender } from '../api/hooks/patient';
import { StimPatientGender } from '../api/hooks/stim';

const GenderUtils = {
  displayName: (gender?: Gender | null) => {
    switch (gender) {
      case Gender.Female:
        return '여';
      case Gender.Male:
        return '남';
      case Gender.Other:
        return '기타';
      default:
        return '';
    }
  },
  stimDisplayName: (gender?: StimPatientGender | null) => {
    switch (gender) {
      case StimPatientGender.Female:
        return '여';
      case StimPatientGender.Male:
        return '남';
      default:
        return '기타';
    }
  },
};

export default GenderUtils;
